import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@mui/material/Button";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

function PesquisaCredito(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        color="default"
        style={{ borderRadius: "1rem 1rem 0 0" }}>
        <Container>
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              Pesquisa de Crédito
            </Typography>
            <IconButton onClick={props.fecharModal} aria-label="info">
              <CloseIcon style={{ width: "32px", marginBottom: "1px" }} />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

PesquisaCredito.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PesquisaCredito);
